function mergeAuthState(currentState, nextState) {
  if (!nextState) {
    return nextState;
  }

  if (nextState.user !== undefined) {
    return nextState;
  }

  const preservedUser = currentState?.user;
  if (preservedUser === undefined) {
    return nextState;
  }

  return {
    ...nextState,
    user: preservedUser,
  };
}

export { mergeAuthState };
